import React, { useEffect, useState } from "react";
import { Button } from "../ui";
import LudDashboardModal from "./LudDashboardModal";
import { useSubmitGuard } from "./modalHooks";

const STATUSES = [
  ["new", "جديد", "New"],
  ["inProgress", "جاري العمل", "In Progress"],
  ["active", "فعال", "Active"],
  ["temporarilyClosed", "مغلق مؤقت", "Temporarily Closed"],
  ["closed", "مغلق", "Closed"],
];

export default function BranchStatusModal({ open, lang, branch, onClose, onSave }) {
  // Repeat clicks are ignored while a save returned by the caller is running.
  const [saving, runSave] = useSubmitGuard();
  const [status, setStatus] = useState("active");

  useEffect(() => {
    if (open) setStatus(branch?.status || "active");
    // Initialise when the modal opens or the entity changes, not whenever the
    // parent passes a new object/array for the same data (that wiped edits).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, branch?.id]);

  return (
    <LudDashboardModal
      open={open}
      busy={saving}
      title={lang === "ar" ? "تغيير حالة الفرع" : "Change Branch Status"}
      onClose={onClose}
      footer={
        <>
         <Button  variant="primary" appearance="filled" onClick={() => runSave(onSave, status)} disabled={saving} loading={saving}>
            {lang === "ar" ? "حفظ الحالة" : "Save Status"}
          </Button>
          <Button variant="danger" appearance="soft" onClick={onClose}>
            {lang === "ar" ? "إلغاء" : "Cancel"}
          </Button>
         
        </>
      }
    >
      <div className="lud-branch-status-options">
        {STATUSES.map(([value, ar, en]) => (
          <label key={value} className={`lud-branch-status-option ${status === value ? "selected" : ""}`}>
            <input type="radio" name="branch-status" value={value} checked={status === value} onChange={() => setStatus(value)} />
            <span>{lang === "ar" ? ar : en}</span>
          </label>
        ))}
      </div>
    </LudDashboardModal>
  );
}
